﻿// ============================================================================
// MÓDULO 3: DESIGN UI (VERSÃO 8.0 - NAVBAR INTELIGENTE)
// ARQUIVO: src/components/layout/LegalDesignUI.jsx
// OBJETIVO: Navbar com estado de usuário e Layout Rico restaurado.
// ============================================================================
import React, { useState, useEffect } from 'react';
import { LAW_FIRM_INFO, ASSETS } from '../../config/Config';
import { HeaderLogo, FooterLogo } from '../ui/Branding';

// --- 1. COMPONENTE: PÁGINA EM CONSTRUÇÃO (ACADEMIA) ---
export const UnderConstruction = ({ onNavigate }) => (
  <div className="min-h-[70vh] flex flex-col items-center justify-center bg-gray-50 text-center px-6 animate-fade-in-up">
    <div className="mb-8">
      <i className="fas fa-graduation-cap text-6xl text-[#20243B]"></i>
    </div>
    <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#20243B] mb-4">
      Academia em desenvolvimento
    </h2>
    <div className="w-16 h-1 bg-[#C5A059] mb-6 rounded-full"></div>
    <p className="text-gray-600 max-w-lg mb-8 text-sm leading-relaxed">
      Estamos estruturando um ambiente de aprendizado.
    </p>
    <button onClick={() => onNavigate('homepage')} className="px-6 py-3 border border-gray-300 text-gray-500 rounded-lg text-xs font-bold uppercase hover:bg-white hover:border-[#20243B] hover:text-[#20243B] transition-all">
      Voltar ao Início
    </button>
  </div>
);

// --- 2. COMPONENTE: COOKIES AVANÇADO ---
export const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showConfig, setShowConfig] = useState(false);
  
  useEffect(() => {
    const consent = localStorage.getItem('rda_cookie_consent');
    if (!consent) setTimeout(() => setShowBanner(true), 1500);
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('rda_cookie_consent', 'accepted_all');
    setShowBanner(false);
  };

  const handleSaveConfig = () => {
    localStorage.setItem('rda_cookie_consent', 'custom');
    setShowConfig(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
        {!showConfig && (
            <div className="fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:max-w-md z-[60] animate-fade-in-up">
            <div className="bg-[#1a1e30]/95 backdrop-blur shadow-2xl p-6 rounded-lg border-l-4 border-[#C5A059] flex flex-col gap-4">
                <div>
                    <h4 className="text-white font-bold text-sm mb-1 flex items-center gap-2">
                        <i className="fas fa-cookie-bite text-[#C5A059]"></i> Privacidade e Dados
                    </h4>
                    <p className="text-gray-300 text-xs leading-relaxed">
                        Utilizamos cookies para garantir a segurança do Portal do Cliente e melhorar a navegação.
                    </p>
                </div>
                <div className="flex gap-2">
                    <button onClick={handleAcceptAll} className="flex-1 bg-[#C5A059] hover:bg-yellow-600 text-[#1a1e30] font-bold py-2 px-4 rounded text-xs uppercase transition-colors">
                        Aceitar
                    </button>
                    <button onClick={() => setShowConfig(true)} className="px-4 py-2 text-gray-400 hover:text-white text-xs font-bold underline transition-colors">
                        Configurar
                    </button>
                </div>
            </div>
            </div>
        )}

        {showConfig && (
            <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden border-t-4 border-[#20243B]">
                    <div className="p-4 border-b bg-gray-50 flex justify-between items-center">
                        <h3 className="font-bold text-gray-800 text-sm">Preferências de Cookies</h3>
                        <button onClick={() => setShowConfig(false)}><i className="fas fa-times text-gray-400"></i></button>
                    </div>
                    <div className="p-6 space-y-4">
                        <div className="flex items-start gap-3">
                            <input type="checkbox" checked disabled className="mt-1" />
                            <div>
                                <p className="text-xs font-bold text-gray-800">Essenciais (Obrigatório)</p>
                                <p className="text-[10px] text-gray-500">Necessários para login e segurança do site.</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-3">
                            <input type="checkbox" defaultChecked />
                            <div>
                                <p className="text-xs font-bold text-gray-800">Analíticos</p>
                                <p className="text-[10px] text-gray-500">Ajudam a entender como o site é usado (Anônimo).</p>
                            </div>
                        </div>
                    </div>
                    <div className="p-4 bg-gray-50 flex justify-end">
                        <button onClick={handleSaveConfig} className="px-6 py-2.5 text-xs font-bold text-white bg-[#20243B] border border-[#20243B] shadow-md hover:bg-[#1a1e30] hover:shadow-lg rounded-lg flex items-center gap-2 transition-transform active:scale-95">Salvar Preferências</button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
};

// --- 3. NAVBAR INTELIGENTE (ATUALIZADA) ---
export const Navbar = React.memo(function Navbar({ onNavigate, user, onLogout }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const navItems = [
    { label: "Áreas de Atuação", id: "areas" },
    { label: "Academia Jurídica", id: "academia" },
    { label: "Sobre Mim", id: "about" }
  ];

  return (
    <header className="w-full z-30 bg-[#20243B] shadow-lg sticky top-0 border-b border-white/10 h-24 md:h-28 transition-none transform-gpu">
      <div className="w-full h-full max-w-[1600px] mx-auto">
        <nav className="w-full h-full px-4 lg:px-8 flex items-center justify-between flex-nowrap">
          
          {/* LOGO CONTAINER: LARGURA AUMENTADA PARA 380px PARA CABER O NOME */}
          <div className="flex-shrink-0 flex items-center mr-2 w-[300px] md:w-[380px] h-full overflow-hidden select-none"> 
            <a href="#" onClick={(e) => { e.preventDefault(); onNavigate('homepage'); }} className="flex w-full h-full hover:opacity-90 transition-opacity items-center">
              {/* USO DO COMPONENTE ESTÁTICO AQUI */}
              <HeaderLogo />
            </a>
          </div>
          
          <div className="hidden md:flex flex-1 justify-center items-center h-full whitespace-nowrap overflow-hidden px-2 lg:px-4">
            <div className="flex items-center gap-4 lg:gap-8"> 
                          {navItems.map((item) => (
                <button key={item.id} onClick={() => onNavigate(item.id)} className="group relative py-2 px-1">
                  <span className="text-gray-300 group-hover:text-[#C5A059] font-medium text-[9px] lg:text-[10px] uppercase tracking-widest transition-colors">{item.label}</span>
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C5A059] transition-all duration-300 group-hover:w-full opacity-0 group-hover:opacity-100"></span>
                </button>
              ))}
            </div>
          </div>
          
          <div className="hidden lg:flex items-center gap-4 flex-shrink-0 ml-4 lg:ml-8 w-[300px] md:w-[380px] justify-end">
            <a href={LAW_FIRM_INFO.contact.whatsappLink} target="_blank" rel="noreferrer" className="h-9 px-6 bg-[#C5A059]/10 text-[#C5A059] border border-[#C5A059] font-bold rounded hover:bg-[#C5A059] hover:text-[#20243B] transition-all text-[10px] uppercase tracking-wider flex items-center justify-center gap-2"><i className="fab fa-whatsapp text-sm"></i> <span>Contato</span></a>
            
            {/* LÓGICA DE LOGIN/LOGOUT INTELIGENTE */}
            {user ? (
                <div className="flex items-center gap-2">
                    <button onClick={() => onNavigate('client')} className="h-9 px-4 text-white border border-white/10 font-bold rounded hover:bg-white hover:text-[#20243B] transition-all text-[10px] uppercase tracking-wider flex items-center justify-center gap-2">
                        <i className="fas fa-user-circle text-xs"></i> Minha Conta
                    </button>
                    {onLogout && (
                        <button onClick={onLogout} className="h-9 w-9 text-red-400 border border-red-500/20 font-bold rounded hover:bg-red-500 hover:text-white transition-all flex items-center justify-center" title="Sair">
                            <i className="fas fa-sign-out-alt"></i>
                        </button>
                    )}
                </div>
            ) : (
                <button onClick={() => onNavigate('client')} className="h-9 px-6 text-white border border-white/10 font-bold rounded hover:bg-white hover:text-[#20243B] transition-all text-[10px] uppercase tracking-wider flex items-center justify-center gap-2">
                    <i className="fas fa-lock text-xs"></i> Login
                </button>
            )}
          </div>
          
          <div className="lg:hidden flex items-center justify-end flex-1 ml-auto">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white p-2"><i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i></button>
          </div>
        </nav>
      </div>
      {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 w-full bg-[#1a1e30] border-t border-white/10 shadow-xl z-50 animate-fade-in-up">
          <div className="flex flex-col p-4 space-y-2">
            {navItems.map((item) => <button key={item.id} onClick={() => { onNavigate(item.id); setIsMobileMenuOpen(false); }} className="text-left text-gray-300 hover:text-white py-3 px-4 border-b border-white/5 font-medium text-sm uppercase tracking-wide">{item.label}</button>)}
            <div className="pt-4 flex flex-col gap-3">
                {user ? (
                    <>
                        <button onClick={() => { onNavigate('client'); setIsMobileMenuOpen(false); }} className="bg-white/10 text-white py-3 rounded-lg font-bold text-sm flex items-center justify-center gap-2 uppercase"><i className="fas fa-user-circle"></i> Minha Conta</button>
                        {onLogout && <button onClick={() => { onLogout(); setIsMobileMenuOpen(false); }} className="border border-red-500/30 text-red-400 py-3 rounded-lg font-bold text-sm flex items-center justify-center gap-2 uppercase"><i className="fas fa-sign-out-alt"></i> Sair</button>}
                    </>
                ) : (
                    <button onClick={() => { onNavigate('client'); setIsMobileMenuOpen(false); }} className="bg-white/10 text-white py-3 rounded-lg font-bold text-sm flex items-center justify-center gap-2 uppercase"><i className="fas fa-lock"></i> Portal do Cliente</button>
                )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
});

// --- 4. HERO SECTION ---
export const HeroSection = ({ onNavigate }) => {
  const [hoverSide, setHoverSide] = useState(null);

  return (
    <div className="relative w-full h-[calc(100vh-112px)] min-h-[600px] flex flex-col lg:flex-row overflow-hidden bg-[#20243B]">
      <div
        className="relative flex-1 lg:w-1/2 flex flex-col items-center p-0 cursor-pointer group border-b-2 lg:border-b-0 lg:border-r-2 border-white/20 overflow-hidden transition-all duration-700"
        onMouseEnter={() => setHoverSide('left')}
        onMouseLeave={() => setHoverSide(null)}
        onClick={() => onNavigate && onNavigate('areas')}
      >
        <div className="absolute inset-0 bg-cover bg-center opacity-20 group-hover:scale-105 transition-transform duration-1000 ease-out" style={{ backgroundImage: `url(${ASSETS.bannerHero})` }}></div>
        <div className={`absolute inset-0 bg-[#20243B]/88 transition-opacity duration-500 ${hoverSide === 'right' ? 'opacity-93' : 'opacity-88'}`}></div>

        <div className={`relative z-10 w-full max-w-[38rem] px-6 lg:px-8 flex flex-col items-center pt-24 lg:pt-28 h-full transition-all duration-500 ${hoverSide === 'right' ? 'opacity-70 scale-[0.985]' : 'opacity-100 scale-100'}`}>
          <div className="mb-9 p-5 rounded-full border border-[#C5A059]/35 bg-[#C5A059]/10 backdrop-blur-md group-hover:border-[#C5A059]/60 group-hover:bg-[#C5A059]/14 transition-colors shadow-2xl"><i className="fas fa-scale-balanced text-4xl text-[#C5A059]"></i></div>

          <div className="min-h-[176px] flex flex-col items-center justify-start text-center">
            <h2 className="text-4xl md:text-5xl lg:text-[3.35rem] font-serif font-bold text-white mb-5 tracking-tight leading-[1.05]">
              <span className="whitespace-nowrap">Advocacia Técnica</span><br />
              <span>e Estratégica</span>
            </h2>
            <p className="text-[#C5A059] font-semibold text-[0.8rem] tracking-[0.24em] uppercase drop-shadow-[0_1px_8px_rgba(197,160,89,0.18)]">Defesa de Direitos Fundamentais</p>
          </div>

          <div className="min-h-[112px] flex items-start justify-center mb-10 border-t-2 border-[#C5A059]/75 pt-5 w-full">
            <p className="text-gray-200 text-[0.95rem] leading-relaxed max-w-md font-light text-center">
              Atuação artesanal em Direito Animal, Cível e Criminal. Foco na técnica jurídica e na segurança processual.
            </p>
          </div>

          <div className="mt-auto pb-16 lg:pb-24 w-full flex justify-center">
            <span className="inline-flex items-center justify-center w-72 text-center bg-white/20 border border-white text-white font-bold text-xs uppercase tracking-[0.22em] py-4 rounded hover:bg-white hover:text-[#20243B] hover:border-white transition-all duration-300 shadow-lg hover:shadow-white/20">
              Consultar Advocacia
            </span>
          </div>
        </div>
      </div>

      <div
        className="relative flex-1 lg:w-1/2 flex flex-col items-center p-0 cursor-pointer group overflow-hidden transition-all duration-700"
        onMouseEnter={() => setHoverSide('right')}
        onMouseLeave={() => setHoverSide(null)}
        onClick={() => onNavigate && onNavigate('academia')}
      >
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-center opacity-30 mix-blend-overlay group-hover:scale-105 transition-transform duration-1000 ease-out"></div>
        <div className={`absolute inset-0 bg-[#2f67a5]/68 transition-opacity duration-500 ${hoverSide === 'left' ? 'opacity-74' : 'opacity-68'}`}></div>

        <div className={`relative z-10 w-full max-w-[34rem] px-6 lg:px-8 flex flex-col items-center pt-24 lg:pt-28 h-full transition-all duration-500 ${hoverSide === 'left' ? 'opacity-70 scale-[0.985]' : 'opacity-100 scale-100'}`}>
          <div className="mb-9 p-5 rounded-full border border-[#C5A059]/35 bg-[#C5A059]/10 backdrop-blur-md group-hover:bg-[#C5A059]/16 group-hover:border-[#C5A059]/60 transition-colors shadow-2xl"><i className="fas fa-graduation-cap text-4xl text-[#C5A059]"></i></div>

          <div className="min-h-[176px] flex flex-col items-center justify-start text-center">
            <h2 className="text-4xl md:text-5xl lg:text-[3.35rem] font-serif font-bold text-white mb-5 tracking-tight leading-[1.05]">Academia <br />Jurídica Digital</h2>
            <p className="text-[#C5A059] font-semibold text-[0.8rem] tracking-[0.24em] uppercase drop-shadow-[0_1px_8px_rgba(197,160,89,0.18)]">Difusão do Conhecimento Científico</p>
          </div>

          <div className="min-h-[112px] flex items-start justify-center mb-10 border-t-2 border-[#C5A059]/75 pt-5 w-full">
            <p className="text-gray-200 text-[0.95rem] leading-relaxed max-w-md font-light text-center">A Academia Rodrigo Demeterco é dedicada ao ensino jurídico de alta precisão. Da resolução estratégica de provas à prática forense: formamos pensadores, não apenas repetidores.</p>
          </div>

          <div className="mt-auto pb-16 lg:pb-24 w-full flex justify-center">
            <span className="inline-flex items-center justify-center w-72 text-center bg-[#C5A059]/20 border border-[#C5A059] text-[#C5A059] font-bold text-xs uppercase tracking-[0.22em] py-4 rounded hover:bg-[#C5A059] hover:text-[#20243B] transition-all duration-300 shadow-lg hover:shadow-[#C5A059]/20">Acessar Academia</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ServiceCard = ({ icon, title, description, onClick }) => (
  <div onClick={onClick} className="bg-white p-8 rounded-xl shadow-lg border border-gray-400 flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl cursor-pointer h-full group relative overflow-hidden hover:border-[#C5A059]">
    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#20243B] to-[#C5A059] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
    <div className="bg-blue-50 p-4 rounded-full mb-6 group-hover:bg-[#20243B] transition-colors duration-300"><i className={`fas ${icon} text-3xl text-[#20243B] group-hover:text-[#C5A059] transition-colors duration-300`}></i></div>
    <h3 className="text-lg font-serif font-bold text-[#1a1e30] mb-3 group-hover:text-[#20243B] transition-colors">{title}</h3>
    <p className="text-gray-600 text-sm mb-6 flex-grow leading-relaxed">{description}</p>
  </div>
);

export const Footer = ({ onNavigate }) => {
  const currentYear = new Date().getFullYear();
  const instagramUrl = String(LAW_FIRM_INFO?.social?.instagram || '').trim();
  const linkedinUrl = String(LAW_FIRM_INFO?.social?.linkedin || '').trim();
  const hasInstagram = instagramUrl && instagramUrl !== '#' && !instagramUrl.toLowerCase().startsWith('javascript:');
  const hasLinkedin = linkedinUrl && linkedinUrl !== '#' && !linkedinUrl.toLowerCase().startsWith('javascript:');

  return (
    <footer className="bg-[#1a1e30] text-white pt-16 pb-16 border-t-4 border-[#C5A059] overflow-hidden relative">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-[1600px] mx-auto">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 mb-12">
          
          {/* COLUNA 1: INFO E LOGO */}
          <div className="space-y-4 lg:col-span-4">
            {/* USO DO COMPONENTE ESTÁTICO */}
            <FooterLogo />
            
            <p className="text-gray-300 text-xs leading-relaxed max-w-sm text-justify">
                Atuação jurídica pautada na ética, técnica e transparência. Compromisso com a defesa intransigente dos direitos de nossos constituintes.
            </p>
            <div className="inline-block bg-white/5 px-3 py-1 rounded text-xs font-semibold text-[#C5A059] border border-[#C5A059]/20">{LAW_FIRM_INFO.oab}</div>
          </div>
          
          {/* COLUNA 2: NAVEGAÇÃO */}
          <div className="space-y-4 lg:col-span-2 lg:pl-8">
            <h4 className="text-sm font-bold text-white border-b border-gray-700 pb-2 inline-block font-serif">Navegação</h4>
            <ul className="space-y-2 text-xs text-gray-300">
              <li><button onClick={() => onNavigate('areas')} className="hover:text-[#C5A059] transition-colors">Áreas de Atuação</button></li>
              <li><button onClick={() => onNavigate('academia')} className="hover:text-[#C5A059] transition-colors">Academia Jurídica</button></li>
              <li><button onClick={() => onNavigate('about')} className="hover:text-[#C5A059] transition-colors">Sobre Mim</button></li>
              <li><button onClick={() => onNavigate('privacidade')} className="hover:text-[#C5A059] transition-colors">Política de Privacidade</button></li>
            </ul>
          </div>
          
          {/* COLUNA 3: CONTATO */}
          <div className="space-y-4 lg:col-span-3">
            <h4 className="text-sm font-bold text-white border-b border-gray-700 pb-2 inline-block font-serif">Contato</h4>
            <ul className="space-y-3 text-xs text-gray-300">
              <li className="flex items-start gap-3">
                  <i className="fas fa-map-marker-alt mt-0.5 text-[#C5A059]"></i>
                  <span>{LAW_FIRM_INFO.address}</span>
              </li>
              <li className="flex items-center gap-3">
                  <i className="fab fa-whatsapp text-[#C5A059]"></i>
                  <a href={LAW_FIRM_INFO.contact.whatsappLink} target="_blank" rel="noreferrer" className="hover:text-white transition-colors">{LAW_FIRM_INFO.contact.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                  <i className="fas fa-envelope text-[#C5A059]"></i>
                  <a href={`mailto:${LAW_FIRM_INFO.contact.email}`} className="hover:text-white transition-colors">{LAW_FIRM_INFO.contact.email}</a>
              </li>
            </ul>
          </div>
          
          {/* COLUNA 4: REDES */}
          <div className="space-y-4 lg:col-span-3">
            <h4 className="text-sm font-bold text-white border-b border-gray-700 pb-2 inline-block font-serif">Conecte-se</h4>
            <div className="flex gap-4">
              {hasInstagram ? (
                <a href={instagramUrl} target="_blank" rel="noreferrer" className="w-9 h-9 rounded bg-white/5 flex items-center justify-center hover:bg-[#C5A059] hover:text-[#1a1e30] transition-all border border-white/10"><i className="fab fa-instagram text-sm"></i></a>
              ) : (
                <span className="w-9 h-9 rounded bg-white/5 flex items-center justify-center border border-white/10 opacity-40 cursor-not-allowed"><i className="fab fa-instagram text-sm"></i></span>
              )}
              {hasLinkedin ? (
                <a href={linkedinUrl} target="_blank" rel="noreferrer" className="w-9 h-9 rounded bg-white/5 flex items-center justify-center hover:bg-[#C5A059] hover:text-[#1a1e30] transition-all border border-white/10"><i className="fab fa-linkedin-in text-sm"></i></a>
              ) : (
                <span className="w-9 h-9 rounded bg-white/5 flex items-center justify-center border border-white/10 opacity-40 cursor-not-allowed"><i className="fab fa-linkedin-in text-sm"></i></span>
              )}
            </div>
          </div>
        </div>
        
                        {/* FRASE DE MANIFESTO (IDENTIDADE ÉTICA) */}
        <div className="border-t border-white/10 pt-10 mt-10 mb-10 text-center px-4">
            <p className="text-white/90 font-serif italic text-lg md:text-xl tracking-wide leading-relaxed max-w-4xl mx-auto">
                "Se um único animal tiver que morrer para que eu sobreviva, deixe-me morrer, pois a minha vida não é mais importante que a dele."
            </p>
            <div className="mt-6 flex items-center justify-center gap-4 opacity-80">
                <span className="h-px w-12 bg-[#C5A059]"></span>
                <span className="text-[#C5A059] font-bold tracking-[0.2em] text-xs uppercase">Rodrigo Demeterco</span>
                <span className="h-px w-12 bg-[#C5A059]"></span>
            </div>
        </div>

        {/* AVISO LEGAL E LGPD */}
        <div className="border-t border-white/20 pt-12 space-y-8">
          <div className="grid md:grid-cols-2 gap-10">
            <div>
                <h5 className="text-[10px] font-bold text-[#C5A059] uppercase tracking-widest mb-3 flex items-center gap-2"><i className="fas fa-balance-scale"></i> Aviso Legal (Compliance OAB)</h5>
                <p className="text-gray-300 text-[11px] leading-relaxed text-justify font-medium">
                    As informações contidas neste site têm caráter meramente informativo e educacional, não constituindo aconselhamento jurídico ou parecer legal. O uso deste site não cria relação advogado-cliente.
                </p>
            </div>
            <div>
                <h5 className="text-[10px] font-bold text-[#C5A059] uppercase tracking-widest mb-3 flex items-center gap-2"><i className="fas fa-shield-alt"></i> Segurança de Dados (LGPD)</h5>
                <p className="text-gray-300 text-[11px] leading-relaxed text-justify font-medium">
                    Compromisso com a proteção de dados pessoais (Lei 13.709/2018). Dados trafegam sob criptografia (TLS) e ficam sob controle de acesso restrito.{' '}
                    <button onClick={() => onNavigate('privacidade')} className="underline hover:text-[#C5A059] transition-colors font-bold">Ler a política completa →</button>
                </p>
            </div>
          </div>
        </div>
        
        <div className="text-center text-gray-400 text-[10px] mt-12 flex flex-col md:flex-row justify-center items-center gap-4 border-t border-white/10 pt-6 font-bold">
            <span>&copy; {currentYear} Rodrigo Demeterco. Todos os direitos reservados.</span>
            <span className="hidden md:inline">|</span>
            <span>Desenvolvido com Tecnologia RDA Legal Ops.</span>
        </div>
      </div>
    </footer>
  );
};

export const WhatsAppFloat = () => (
  <a href={`${LAW_FIRM_INFO.contact.whatsappLink}?text=Olá,%20vim%20pelo%20site.`} target="_blank" rel="noopener noreferrer" className="hidden lg:flex fixed bottom-8 right-8 bg-[#25D366] text-white w-14 h-14 rounded-full items-center justify-center shadow-lg z-50 hover:scale-110 transition-transform animate-bounce-slow hover:shadow-green-500/30" title="Fale conosco no WhatsApp"><i className="fab fa-whatsapp text-3xl"></i></a>
);

export const MobileBottomNav = ({ onNavigate, activeTab }) => {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 z-40 flex justify-around py-3 pb-safe shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
      <button onClick={() => onNavigate('areas')} className={`flex flex-col items-center gap-1 ${activeTab === 'areas' ? 'text-[#20243B]' : 'text-gray-400'}`}><i className="fas fa-balance-scale text-lg"></i><span className="text-[10px] font-bold uppercase">Áreas</span></button>
      <button onClick={() => onNavigate('academia')} className={`flex flex-col items-center gap-1 ${activeTab === 'academia' ? 'text-[#20243B]' : 'text-gray-400'}`}><i className="fas fa-graduation-cap text-lg"></i><span className="text-[10px] font-bold uppercase">Acad</span></button>
      <button onClick={() => onNavigate('about')} className={`flex flex-col items-center gap-1 ${activeTab === 'about' ? 'text-[#20243B]' : 'text-gray-400'}`}><i className="fas fa-user text-lg"></i><span className="text-[10px] font-bold uppercase">Sobre</span></button>
      <button onClick={() => onNavigate('client')} className={`flex flex-col items-center gap-1 ${activeTab === 'client' ? 'text-[#C5A059]' : 'text-gray-400'}`}><i className="fas fa-lock text-lg"></i><span className="text-[10px] font-bold uppercase">Cliente</span></button>
      <button onClick={() => window.open(LAW_FIRM_INFO.contact.whatsappLink, '_blank')} className="flex flex-col items-center gap-1 text-green-600"><i className="fab fa-whatsapp text-lg"></i><span className="text-[10px] font-bold uppercase">Whats</span></button>
    </div>
  );
};
